(function () {
    angular.module('tmx-app')
        .controller('currencyEditCtrl', ['$stateParams', '$state', 'resolvedData', 'CurrencyService','ToastService', 
            function CurrencyEditCtrl( $stateParams, $state, resolvedData, CurrencyService,ToastService) {
                var currencyVM = this;
                currencyVM.vm = resolvedData.Currency.data;
                if (currencyVM.vm.TmxCurrencyRate!=null && currencyVM.vm.TmxCurrencyRate.length > 0) {
                    currencyVM.vm.TmxCurrencyRate = filterAndSortByCurrencyRateId(currencyVM.vm.TmxCurrencyRate);
                    if(currencyVM.vm.TmxCurrencyRate.length>0){
                        currencyVM.BaseFactor = currencyVM.vm.TmxCurrencyRate[0].BaseFactor; 
                    }
                    else{
                        currencyVM.BaseFactor =0;
                    }
                               
                }
                else{
                    currencyVM.BaseFactor =0;
                }
                currencyVM.readonly = true;

                currencyVM.save = function () {
                    if (currencyVM.vm.TmxCurrencyRate.length > 0) {
                        if (currencyVM.BaseFactor != currencyVM.vm.TmxCurrencyRate[0].BaseFactor) {
                            currencyVM.vm.TmxCurrencyRate.push(
                                {
                                    ActiveFlag: 1,
                                    BaseFactor: currencyVM.BaseFactor,
                                    CurrencyID: $stateParams.Id
                                }
                            )
                        }                
                    }
                    else {
                        currencyVM.vm.TmxCurrencyRate.push(
                            {
                                ActiveFlag:1,
                                BaseFactor:currencyVM.BaseFactor,
                                CurrencyID:$stateParams.Id
                            }
                        )
                    }

                    CurrencyService.getByAction('', false, 'put', currencyVM.vm).then(function (response) {                
                        if(response) {
                            ToastService.showCustomToast("success",response.status.message);                    
                        }                
                        $state.go("^");
                    });
                }

                currencyVM.cancel = function () {
                    $state.go("^");
                }

                function filterAndSortByCurrencyRateId (TmxCurrencyRate) {
                    TmxCurrencyRate = TmxCurrencyRate.filter(function(item){ return item.ActiveFlag == 1 });
                    TmxCurrencyRate = TmxCurrencyRate.sort((a, b) => parseFloat(a.CurrencyRateID) - parseFloat(b.CurrencyRateID));            
                    return TmxCurrencyRate;
                }
            }]);
})();

